/**
 * The site's addresses, in one place.
 *
 * The carousel is the index. Its panels (the About panel and the case
 * studies) are one segment deep, "/<slug>": see CaseStudy/registry.ts for
 * the slug list and the path helpers, and App.tsx for the route table.
 * The book, the old About page, keeps a real URL so it can be shared once
 * found, but nothing links to it: it is behind the flying book at the end
 * of the About panel. The old landing page, the avatar office, has no
 * address of its own any more: it is the 404 (pages/NotFound).
 *
 * The carousel used to live at /portfolio (panels at /portfolio/<slug>).
 * Those addresses redirect: public/_redirects on Netlify, and the first
 * script in index.html for any other host, before anything reads the URL.
 * The bare /portfolio was the shared address of the site, so it must keep
 * landing on the carousel: no panel may take a slug of "portfolio" (this
 * site's own case study is "portfolio-site"; src/routes.test.ts guards it).
 */
export const ROUTES = {
    /** The carousel. */
    index: "/",
    /** The About panel, over the carousel. */
    about: "/about",
    /** The 3D book: the old About page. Unlinked; the About panel's door. */
    book: "/book",
} as const;
